import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import {MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {ReactiveFormsModule} from "@angular/forms";

import {AdminRoutingModule} from "./admin-routing.module";
import {SharedModule} from "../shared/shared.module";

import {UserListComponent} from "./user/user-list/user-list.component";
import {AddNewUserDialogComponent} from "./user/add-new-user-dialog/add-new-user-dialog.component";
import {ShowroomListComponent} from "./showroom/showroom-list/showroom-list.component";
import {AddNewShowroomDialogComponent} from "./showroom/add-new-showroom-dialog/add-new-showroom-dialog.component";
// import { LeadSourceListComponent } from './lead-source-list/lead-source-list.component';
// import { AddNewLeadSourceDialogComponent } from './add-new-lead-source-dialog/add-new-lead-source-dialog.component';
import {WebsiteListComponent} from "./website/website-list/website-list.component";
import {AddNewWebsiteDialogComponent} from "./website/add-new-website-dialog/add-new-website-dialog.component";
import {EditShowroomDialogComponent} from "./showroom/edit-showroom-dialog/edit-showroom-dialog.component";
import {JobFunctionListComponent} from "./job-function/job-function-list/job-function-list.component";
import {AddNewJobFunctionDialogComponent} from "./job-function/add-new-job-function-dialog/add-new-job-function-dialog.component";
import {EditUserDialogComponent} from "./user/edit-user-dialog/edit-user-dialog.component";
import {ContactTypeListComponent} from "./contact-type/contact-type-list/contact-type-list.component";
import {AddNewContactTypeDialogComponent} from "./contact-type/add-new-contact-type-dialog/add-new-contact-type-dialog.component";
import {ContactSourceListComponent} from "./contact-source/contact-source-list/contact-source-list.component";
import {AddNewContactSourceDialogComponent} from "./contact-source/add-new-contact-source-dialog/add-new-contact-source-dialog.component";
import {EditContactTypeDialogComponent} from "./contact-type/edit-contact-type-dialog/edit-contact-type-dialog.component";
import {EditContactSourceDialogComponent} from "./contact-source/edit-contact-source-dialog/edit-contact-source-dialog.component";
import {ProjectStatusListComponent} from "./project-status/project-status-list/project-status-list.component";
import {AddProjectStatusDialogComponent} from "./project-status/add-project-status-dialog/add-project-status-dialog.component";
import {EditJobFunctionDialogComponent} from "./job-function/edit-job-function-dialog/edit-job-function-dialog.component";
import {EditProjectStatusDialogComponent} from "./project-status/edit-project-status-dialog/edit-project-status-dialog.component";
import {EditWebsiteDialogComponent} from "./website/edit-website-dialog/edit-website-dialog.component";
import {ProjectMapStepComponent} from "./project-map/project-map-step/project-map-step.component";
import {AddProjectMapStepDialogComponent} from "./project-map/add-project-map-step-dialog/add-project-map-step-dialog.component";
import {ProjectMapFieldComponent} from "./project-map/project-map-field/project-map-field.component";
import {EditProjectMapStepDialogComponent} from "./project-map/edit-project-map-step-dialog/edit-project-map-step-dialog.component";
import {PermissionListComponent} from "./permission/permission-list/permission-list.component";
import {AddNewPermissionDialogComponent} from "./permission/add-new-permission-dialog/add-new-permission-dialog.component";
import {EditPermissionDialogComponent} from "./permission/edit-permission-dialog/edit-permission-dialog.component";
import {ClearDatabaseComponent} from "./settings/clear-database/clear-database.component";
import {SettingsComponent} from "./settings/settings/settings.component";
import {ProjectMapStepCategoryComponent} from "./project-map/project-map-step-category/project-map-step-category.component";
import {ProjectMapStepNeededDocsComponent} from "./project-map/project-map-step-needed-docs/project-map-step-needed-docs.component";
import {ListComponent} from "./calender-event-types/list/list.component";
import {AddDialogComponent} from "./calender-event-types/add-dialog/add-dialog.component";
import {EditDialogComponent} from "./calender-event-types/edit-dialog/edit-dialog.component";
import {ImportExportComponent} from "./import-export/import-export.component";
import {CommentTypeListComponent} from "./comment-types/comment-type-list/comment-type-list.component";
import {AddCommentTypeDialogComponent} from "./comment-types/add-comment-type-dialog/add-comment-type-dialog.component";
import {EditCommentTypeDialogComponent} from "./comment-types/edit-comment-type-dialog/edit-comment-type-dialog.component";

import {MarketingListsComponent} from "./marketing-lists/marketing-lists/marketing-lists.component";
import {EditMarketingDialogComponent} from "./marketing-lists/edit-marketing-dialog/edit-marketing-dialog.component";
import {AddMarketingDialogComponent} from "./marketing-lists/add-marketing-dialog/add-marketing-dialog.component";
import {OneTimeComponent} from "./one-time/one-time.component";
import {MarketingListEntriesComponent} from "./marketing-lists/marketing-list-entries/marketing-list-entries.component";
import {SettingsFormComponent} from "./settings/settings-form/settings-form.component";

@NgModule({
  declarations: [
    UserListComponent,
    AddNewUserDialogComponent,
    ShowroomListComponent,
    AddNewShowroomDialogComponent,
    // LeadSourceListComponent,
    // AddNewLeadSourceDialogComponent,
    WebsiteListComponent,
    AddNewWebsiteDialogComponent,
    EditShowroomDialogComponent,
    JobFunctionListComponent,
    AddNewJobFunctionDialogComponent,
    EditUserDialogComponent,
    ContactTypeListComponent,
    AddNewContactTypeDialogComponent,
    ContactSourceListComponent,
    AddNewContactSourceDialogComponent,
    EditContactTypeDialogComponent,
    EditContactSourceDialogComponent,
    ProjectStatusListComponent,
    AddProjectStatusDialogComponent,
    EditJobFunctionDialogComponent,
    EditProjectStatusDialogComponent,
    EditWebsiteDialogComponent,
    ProjectMapStepComponent,
    AddProjectMapStepDialogComponent,
    ProjectMapFieldComponent,
    EditProjectMapStepDialogComponent,
    PermissionListComponent,
    AddNewPermissionDialogComponent,
    EditPermissionDialogComponent,
    ClearDatabaseComponent,
    SettingsComponent,
    ProjectMapStepCategoryComponent,
    ProjectMapStepNeededDocsComponent,
    ListComponent,
    AddDialogComponent,
    EditDialogComponent,
    ImportExportComponent,
    CommentTypeListComponent,
    AddCommentTypeDialogComponent,
    EditCommentTypeDialogComponent,
    MarketingListsComponent,
    EditMarketingDialogComponent,
    AddMarketingDialogComponent,
    OneTimeComponent,
    MarketingListEntriesComponent,
    SettingsFormComponent,
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    SharedModule,
    ReactiveFormsModule,
  ],
  entryComponents: [
    AddNewUserDialogComponent,
    AddNewShowroomDialogComponent,
    AddNewWebsiteDialogComponent,
    EditShowroomDialogComponent,
    AddNewJobFunctionDialogComponent,
    EditUserDialogComponent,
    AddNewContactTypeDialogComponent,
    AddNewContactSourceDialogComponent,
    EditContactTypeDialogComponent,
    EditContactSourceDialogComponent,
    AddProjectStatusDialogComponent,
    EditJobFunctionDialogComponent,
    EditProjectStatusDialogComponent,
    EditWebsiteDialogComponent,
    AddProjectMapStepDialogComponent,
    ProjectMapFieldComponent,
    EditProjectMapStepDialogComponent,
    AddNewPermissionDialogComponent,
    EditPermissionDialogComponent,
    ProjectMapStepCategoryComponent,
    ProjectMapStepNeededDocsComponent,
    AddDialogComponent,
    EditDialogComponent,
    AddCommentTypeDialogComponent,
    EditCommentTypeDialogComponent,
    AddMarketingDialogComponent,
    EditMarketingDialogComponent,
  ],
  providers: [
    {
      provide: MatDialogRef,
    },
  ],
})
export class AdminModule {}
